export default __webpack_public_path__ + "static/media/star-gold.1387c2ee.svg";